
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import { mapGetters, mapActions } from 'vuex'
import * as types from './store/mutations-types'

export default {
directives: {
TransferDom
},

components: {
Grid,
GridItem,
Loading,
Tabbar,
TabbarItem,
ViewBox,
XHeader
},

computed: {
...mapGetters([
'isLoading',
'direction',
'user',
'mainTitle'
]),
viewBottom () {
return this.$route.name === 'Home' || this.$route.name === 'UserInfo' ? '55px' : '0'
},
viewTransition () {
if (!this.direction) return ''
return 'vux-pop-' + (this.direction === 'forward' ? 'in' : 'out')
},
leftOptions () {
return {
showBack: !this.$route.meta.anonymous && this.$route.name !== 'UserInfo',
preventGoBack: false
}
},
headerTransition () {
if (!this.direction) {
return ''
}
return this.direction === 'forward' ? 'vux-header-fade-in-right' : 'vux-header-fade-in-left'
}
},

methods: {
...mapActions([
types.UPDATEUSER
])
}
}



// WEBPACK FOOTER //
// ./src/App.vue